var _g, _defs, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthizoInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 0H1V22H23V0Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5.44511C1.03212 5.25578 1.07519 5.06846 1.129 4.88411C1.44104 3.95928 2.31715 3.3439 3.293 3.36411C7.22633 3.36011 11.1597 3.36011 15.093 3.36411C16.215 3.36411 17.124 4.10511 17.336 5.17211C17.3655 5.33273 17.3796 5.49581 17.378 5.65911C17.378 9.32178 17.378 12.9848 17.378 16.6481C17.3703 17.814 16.4616 18.7751 15.298 18.8481C15.232 18.8481 15.164 18.8531 15.098 18.8531C11.1753 18.8531 7.25233 18.8531 3.329 18.8531C2.45 18.8531 1.772 18.4801 1.312 17.7271C1.15235 17.4603 1.05493 17.1608 1.027 16.8511C1.022 16.8061 1.013 16.7611 1.005 16.7171L1 5.44511Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.373 11.1141C22.373 12.5901 22.373 14.0655 22.373 15.5401C22.3765 15.5904 22.3765 15.6409 22.373 15.6911C22.365 15.7717 22.3195 15.8438 22.2503 15.8857C22.181 15.9276 22.0961 15.9344 22.021 15.9041C21.9669 15.8817 21.9148 15.8549 21.865 15.8241C20.487 15.0555 19.1087 14.2865 17.73 13.5171C17.6458 13.4814 17.5944 13.3952 17.603 13.3041C17.607 11.8375 17.607 10.3708 17.603 8.90413C17.5961 8.81838 17.6448 8.73783 17.724 8.70413C19.114 7.93079 20.503 7.15546 21.891 6.37813C21.9306 6.35446 21.9725 6.33471 22.016 6.31913C22.0975 6.28692 22.1897 6.29728 22.2621 6.34678C22.3344 6.39628 22.3775 6.47847 22.377 6.56613C22.377 6.60813 22.377 6.65013 22.377 6.69213C22.3743 8.16546 22.373 9.63946 22.373 11.1141Z",
    stroke: "#C4C4C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0424 9.7893C14.0238 9.74874 14.0128 9.71917 13.9976 9.69214C13.8042 9.36772 13.6259 9.03146 13.4121 8.72056C12.9103 7.9906 12.2809 7.39836 11.469 7.02156C10.5616 6.59913 9.6103 6.50366 8.62774 6.65743C7.00562 6.91088 5.83972 7.81319 5.08865 9.25028C4.61637 10.1543 4.53189 11.125 4.71522 12.1228C4.72959 12.2014 4.71522 12.2351 4.64003 12.263C4.40939 12.3534 4.18212 12.4506 3.95317 12.5452C3.72421 12.6398 3.49779 12.7345 3.26123 12.8325C3.46568 13.3022 3.66676 13.7618 3.86868 14.229L5.29817 13.5818L5.34717 13.6537C6.55109 15.2935 8.12843 16.1274 10.1958 15.8773C11.0459 15.7764 11.8442 15.4159 12.482 14.8449C13.0979 14.3017 13.5414 13.6334 13.8861 12.895C13.9782 12.6973 14.0601 12.4962 14.1522 12.2841L12.5833 11.9352C12.5107 12.1093 12.4465 12.2732 12.3713 12.4421C12.1505 12.9588 11.8096 13.4152 11.3769 13.7736C10.8708 14.1697 10.2454 14.3827 9.6027 14.3777C8.9699 14.3878 8.36837 14.2763 7.82851 13.9308C6.86622 13.314 6.37958 12.4227 6.35508 11.2864C6.3272 9.98953 6.92198 9.04245 8.04479 8.42148C8.63619 8.09452 9.27405 8.04299 9.93219 8.12325C10.6339 8.19634 11.275 8.55354 11.7064 9.11172C11.7241 9.13538 11.7393 9.16157 11.7605 9.19621L6.90677 11.2847L7.61645 12.5815L14.0424 9.7893Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "text/javascript",
    src: "chrome-extension://hejbmebodbijjdhflfknehhcgaklhano/../window/testing-library.js"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthizoInactive);
export default __webpack_public_path__ + "static/media/ethizo_inactive.1a72912bdbe225096a99096ffaa84a11.svg";
export { ForwardRef as ReactComponent };